var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sideComponent)?_c(_vm.sideComponent,{tag:"component"}):_vm._e(),_c('div',{staticClass:"mw1260"},[_c('alarm-component',{attrs:{"alarmType":'list'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }